import React,{useState, useEffect} from 'react'
import {createOrderAction} from "../../store/order/actions"
import { useSelector,useDispatch } from "react-redux";
import {createUserAction} from "../../store/auth/actions"
import {register,reset} from '../../store/auth/authSlice'
import {createOrder} from '../../store/order/orderSlice'

import {toast} from 'react-toastify'

import Layout from "../layout/Layout"
import { Link,useNavigate } from "react-router-dom";
import { render } from '@react-email/render';
import nodemailer from 'nodemailer';
import EmailTemp from '../email/EmailTemp';
import {generateOrderID} from '../../utils/generateOrderId';

interface CartItem {
    // Define the structure of each item in your cart
    quantity: number;
    // Other properties if present
  }
const Checkout = () => {
    const { orders } = useSelector((state: any) => state.order);
    const {user, isLoading, isError, isSuccess, message} = useSelector(
        (state: any) => state.auth);

    const dispatch = useDispatch<any>();
    const navigate = useNavigate()

    const [firstName,setFirstName] = useState("");
    const [secondName,setSecondName] = useState("");
    const [email,setEmail] = useState("");
    const [password,setPassword] = useState("");

    const [address,setAddress] = useState("");
    const [city,setCity] = useState("");
    const [zipcode,setZipcode] = useState("");
    const [phoneNumber,setPhoneNumber] = useState("");
    const [firstTime,setFirstTime] = useState(true)

    const fullName = firstName + " " + secondName;
    const fullAddress = address + ", " + city + ", " + zipcode;


    const [cartItems, setCartItems] = useState<CartItem[]>([]);
    useEffect(() => {
        const storedCartData = localStorage.getItem("cart");
        (storedCartData) ? setCartItems(JSON.parse(storedCartData) ) : setCartItems([]);
        console.log("cart items -->",cartItems);
        // console.log('authentication----',auth);
        // console.log('order----',order);
        // 
    },[])


    useEffect(() => {
        if(isError) {
            toast.error(message)
        }
        if(isSuccess && user){
            handleOrderSubmit(user?.user?._id)
            removeItems()
            navigate('/')
        }
        
        dispatch(reset())

    },[user,isError,isSuccess,message,navigate,dispatch])

    

    const handleOrderSubmit =  (userId:any) => {
        cartItems?.map((el: any) => (
                    
            dispatch(createOrder( {
                orderID: generateOrderID(),
                product: el?.id,
                quantity: el?.quantity,
                totalPrice: (el?.quantity * el?.price ),
                status: "Processing",
                orderedBy: userId,
            }))
    
        
        ))



    }
    const handleCheckout = () => {
        // console.log("checkout");
        
        if(!fullName || !phoneNumber|| !password || !email || !fullAddress) {
            toast.error('Please fill in all the fields')
        }else{
            const userData = {
            names:fullName,
            phone: phoneNumber,
            nid: "1982766352",
            address: fullAddress,
            email,
            password,
            role: "user"
    
            }
            dispatch(register(userData))
        }
    
        // createUserAction(userData)(dispatch);
    
        // setFirstTime(false);
    
    
      }
    // useEffect(() => {
    //   if(!firstTime){
    //     if(!auth?.isFetching && auth?.isAuth && auth?.token){
    //         if(auth?.user?._id){
    //             console.log("user id -->",auth?.user?._id);
                
    //             handleOrderSubmit(auth?.user?._id);
    //             // handleSendEmail();
    //             // if(order?.status === "success"){
    //                 // handleSendEmail();
    //                 removeItems();
    //                 navigate("/")

                
    //             // /}
        
    //         }else{
    //             console.log("no user id XXXXX")
        
        
    //         }
    //     }
    //     console.log("cart items -->",cartItems);
    //     console.log('authentication----',auth);
    //     console.log('order----',order);
    //     console.log('order status----',order?.status);

    // }


    // },[firstTime,auth?.isFetching,auth?.isAuth])
    
    


  const totalQnty = cartItems
    ?.map((data: any) => data?.quantity)
    ?.reduce((total: number, quantity: number) => (total += quantity), 0);

  const calculateItemTotal = (item: any) => {
    const price = parseFloat(item.price);
    const quantity = parseInt(item.quantity, 10);
    return price * quantity;
  };

  // Calculate the overall cart total
  const cartTotal = cartItems.reduce((total: any, item: any) => {
    return total + calculateItemTotal(item);
  }, 0);
  
  
  

  const removeItems = () => {
 
    localStorage.removeItem("cart");
    const storedCartData = localStorage.getItem("cart");
    
    (storedCartData) ? setCartItems(JSON.parse(storedCartData) ) : setCartItems([]);
    // onClose();
  };

  return (
    <Layout>
    

    <div className="cart-table-area section-padding-100">
    <div className="container-fluid">
        <div className="row">
            <div className="col-12 col-lg-8">
                {/* {user ? ( */}

                    <div className="checkout_details_area mt-50 clearfix">

                    <div className="cart-title">
                        <h2>Checkout</h2>
                    </div>

                    <form action="#" method="post">
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <input type="text" className="form-control" id="first_name" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First Name" required/>
                            </div>
                            <div className="col-md-6 mb-3">
                                <input type="text" className="form-control" id="last_name" value={secondName} onChange={(e) => setSecondName(e.target.value)} placeholder="Last Name" required/>
                            </div>
                            
                            <div className="col-12 mb-3">
                                <input type="email" className="form-control" id="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}/>
                            </div>
                            <div className="col-12 mb-3">
                                <input type="password" className="form-control" id="password" value={password} onChange={(e) => setPassword(e.target.value)}/>
                            </div>
                            {/* <div className="col-12 mb-3">
                                <select className="w-100" id="country">
                                <option value="usa">United States</option>
                                <option value="uk">United Kingdom</option>
                                <option value="ger">Germany</option>
                                <option value="fra">France</option>
                                <option value="ind">India</option>
                                <option value="aus">Australia</option>
                                <option value="bra">Brazil</option>
                                <option value="cana">Canada</option>
                                <option value="rw">Rwanda</option>

                            </select>
                            </div> */}
                            <div className="col-12 mb-3">
                                <input type="text" className="form-control mb-3" id="street_address" placeholder="Address" value={address} onChange={(e) => setAddress(e.target.value)}/>
                            </div>
                            <div className="col-12 mb-3">
                                <input type="text" className="form-control" id="city" placeholder="Town" value={city} onChange={(e) => setCity(e.target.value)}/>
                            </div>
                            <div className="col-md-6 mb-3">
                                <input type="text" className="form-control" id="zipCode" placeholder="Zip Code" value={zipcode} onChange={(e) => setZipcode(e.target.value)}/>
                            </div>
                            <div className="col-md-6 mb-3">
                                <input type="number" className="form-control" id="phone_number" min="0" placeholder="Phone No" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)}/>
                            </div>
                            {/* <div className="col-12 mb-3">
                                <textarea name="comment" className="form-control w-100" id="comment" placeholder="Leave a comment about your order"></textarea>
                            </div> */}
                    {/* 
                            <div className="col-12">
                                <div className="custom-control custom-checkbox d-block mb-2">
                                    <input type="checkbox" className="custom-control-input" id="customCheck2"/>
                                    <label className="custom-control-label" id="customCheck2">Create an account</label>
                                </div>
                                <div className="custom-control custom-checkbox d-block">
                                    <input type="checkbox" className="custom-control-input" id="customCheck3"/>
                                    <label className="custom-control-label" id="customCheck3">Ship to a different address</label>
                                </div>
                            </div> */}
                        </div>
                    </form>
                    </div>

                {/* // ) : ( */}
                {/* //     <h1><Link to={"/login"}>Login</Link> or <Link to={"/register"}>Register</Link></h1> */}

                {/* // )} */}
               
            </div>
            <div className="col-12 col-lg-4">
                <div className="cart-summary">
                    <h5>Cart Total</h5>
                    <ul className="summary-table">
                        <li><span>subtotal:</span> <span>{`RWF ${cartTotal?.toLocaleString()}`}</span></li>
                        {/* <li><span>delivery:</span> <span>Free</span></li> */}
                        <li><span>total:</span> <span>{`RWF ${cartTotal?.toLocaleString()}`}</span></li>
                    </ul>

                    <div className="payment-method">
                        {/* <!-- Cash on delivery --> */}
                        <div className="custom-control custom-checkbox mr-sm-2">
                            <input type="checkbox" className="custom-control-input" id="cod" checked/>
                            <label className="custom-control-label" >Cash on Delivery</label>
                        </div>
                        {/* <!-- Paypal --> */}
                        {/* <div className="custom-control custom-checkbox mr-sm-2">
                            <input type="checkbox" className="custom-control-input" id="paypal"/>
                            <label className="custom-control-label" >Paypal <img className="ml-15" src="img/core-img/paypal.png" alt=""/></label>
                        </div> */}
                    </div>

                    <div className="cart-btn mt-100">
                        <a href="#" className="btn amado-btn w-100" onClick={handleCheckout}>Checkout</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>








    
    
    </Layout>
  )
}

export default Checkout